import { profileListEnum } from '../../models/profileList';
import { routesList } from './routes-list';

const all = [
  profileListEnum.SYSADMIN,
  profileListEnum.CONFIGURATOR,
  profileListEnum.SUPERADMIN,
  profileListEnum.ADMIN,
  profileListEnum.USER,
  profileListEnum.SIGNER,
];
const allButSigner = [
  profileListEnum.SYSADMIN,
  profileListEnum.CONFIGURATOR,
  profileListEnum.SUPERADMIN,
  profileListEnum.ADMIN,
  profileListEnum.USER,
];
const admin = [
  profileListEnum.SYSADMIN,
  profileListEnum.CONFIGURATOR,
  profileListEnum.SUPERADMIN,
  profileListEnum.ADMIN,
];

let persValidator = false;

let actualProfile = null;
let actualJsonConfig = null;
let profileNumber = null;
let actualConfig = null;
let conf = [];
let equals = false;

export function beforeFilter() {
  const profileType = getCookieValue('profileType');
  const profileAccess = getCookieValue('profileAccess');

  if (!profileType || !profileAccess || profileType === 'undefined' || profileAccess === 'undefined') {
    return;
  }

  actualProfile = profileType;
  actualJsonConfig = profileAccess;
  profileNumber = parseInt(actualProfile);
  actualConfig = JSON.parse(actualJsonConfig);

  persValidator = actualConfig.length === 4;
}

function getCookieValue(key: string): string | null {
  const value = document?.cookie?.replace(new RegExp(`(?:(?:^|.*;\\s*)${key}\\s*=\\s*([^;]*).*$)|^.*$`), '$1');
  return value || null;
}

beforeFilter();

export const indexAccessList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
export const routeAccessList = {
  [routesList.CIRCUITS_NEW]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : allButSigner,
  [routesList.TASKS_PENDING]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : all,
  [routesList.CIRCUITS_SENT]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : allButSigner,
  [routesList.CIRCUITS_DRAFT]: allButSigner,
  [routesList.CIRCUITS_ORGANIZATION]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : all,
  [routesList.TASKS_ORGANIZATION]: persValidator
    ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR]
    : allButSigner,
  [routesList.ADMIN]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : admin,
  [routesList.ADMIN_USERS]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : admin,
  [routesList.ADMIN_AREAS]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : admin,
  [routesList.ADMIN_POSITIONS]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : admin,
  [routesList.CIRCUITS_CUSTOM]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : allButSigner,
  [routesList.TASKS_REASSIGN]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : allButSigner,
  [routesList.TASKS_DELEGATIONS]: persValidator
    ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR]
    : allButSigner,
  [routesList.CIRCUITS_MASSIVE_NEW]: persValidator
    ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR]
    : allButSigner,
  [routesList._MORE]: persValidator ? [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR] : all,
  [routesList.ADMIN_USERS_NEW]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR, profileListEnum.SUPERADMIN],
  [routesList.ADMIN_USERS_EDIT]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR, profileListEnum.SUPERADMIN],
  [routesList.ADMIN_POSITIONS_NEW]: admin,
  [routesList.ADMIN_POSITIONS_EDIT]: admin,
  [routesList._MANUAL]: all,
  [routesList._FAQ]: all,
  [routesList.ADMIN_AREAS_EDIT]: [profileListEnum.SUPERADMIN, profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.VERIFICATION]: all,
  [routesList.TASKS]: all,
  [routesList.ADMIN_PROFILES]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR, profileListEnum.SUPERADMIN],
  [routesList.ADMIN_INVITATION]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR, profileListEnum.SUPERADMIN],
  [routesList.CIRCUITS]: all,
  [routesList.CIRCUITS_DETAIL]: all,
  [routesList.CIRCUITS_CUSTOM_NEW]: allButSigner,
  [routesList.CIRCUITS_CUSTOM_EDIT]: allButSigner,
  [routesList.TASKS_DELEGATIONS_NEW]: allButSigner,
  [routesList.TASKS_DELEGATIONS_EDIT]: allButSigner,
  [routesList.COMPANY_RELATIONS]: admin,
  [routesList.COMPANY]: all,
  [routesList.PROFILE]: all,
  [routesList.PANEL]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_USERS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_PERSONALIZATIONS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_ORGANIZATIONS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_CIRCUITS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_SENT_CIRCUITS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_ADMIN_CIRCUITS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_MANAGE_CUSTOM]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_CREDITS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_CUSTOM_CIRCUITS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_TEMPLATES]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_ACCESS_MANAGEMENT]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_PREFIXES]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_WIDGETS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_TERMS_AND_CONDITIONS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_SIGNATURE_TYPE]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_COMPANY_CERTS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_SENDERS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.PANEL_REPROCESS_CALLBACKS]: [profileListEnum.SYSADMIN, profileListEnum.CONFIGURATOR],
  [routesList.CONTACTS]: allButSigner,
};
export function filter() {
  if (!persValidator || actualProfile === '1') return;

  const matchedConfig = getProfileConfig(actualProfile);
  if (!matchedConfig) return;

  conf = matchedConfig.listIdMenu;

  updateRouteAccessList(profileNumber, conf);
}

function getProfileConfig(profile: string) {
  return actualConfig.find((item) => item.idProfile.toString() === profile);
}

function updateRouteAccessList(profileNum: number, configList: number[]) {
  let indexAccess = 0;

  for (const key in routeAccessList) {
    if (indexAccess > 13) break;

    const matched = configList.includes(indexAccessList[indexAccess]);
    if (matched) {
      const profileList = routeAccessList[key];
      if (!profileList.includes(profileNum)) {
        profileList.push(profileNum);
      }
    }

    indexAccess++;

  }
}

filter();
